import React from "react";
import {
  Grid,
  TableBody,
  TableRow,
  CardContent,
  Divider,
  Card,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import { IsEmpty, readableFormatDate } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";

export const EasebuzzDetails = ({ data }) => {
  const easebuzzPaymentModeData = data || {};
  return (
    <Card>
      <CardContent className="card-content_head">
        <Grid container alignItems="center">
          <Grid item lg={6} md={6} sm={8} xs={12}>
            Easebuzz Details
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <CustomTableWrapper>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <table className="w-full">
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Easebuzz Identifier
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {easebuzzPaymentModeData["easebuzz_identifier"]}
                  </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Credentials Of
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {easebuzzPaymentModeData["credentials_of"]}
                  </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Payment Mode
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {easebuzzPaymentModeData["payment_mode"]}
                  </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Status
                  </TableBodyCell>
                  <TableBodyCell>
                    <BootstrapBadge text={easebuzzPaymentModeData["status"]} />
                  </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Bank Reference Identifier
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    <IsEmpty
                      itemKey={easebuzzPaymentModeData}
                      value="bank_reference_identifier"
                    />
                  </TableBodyCell>
                </TableRow>
              </TableBody>
            </table>
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <table className="w-full">
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Error Message
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    <IsEmpty
                      itemKey={easebuzzPaymentModeData}
                      value="error_message"
                    />
                  </TableBodyCell>
                </TableRow>
              </TableBody>

              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Payment Reference No
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {easebuzzPaymentModeData["payment_reference_number"]}
                  </TableBodyCell>
                </TableRow>
              </TableBody>

              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Transaction ID
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    <IsEmpty itemKey={easebuzzPaymentModeData} value="id" />
                  </TableBodyCell>
                </TableRow>
              </TableBody>

              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Created Date
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(easebuzzPaymentModeData["created_at"])}
                  </TableBodyCell>
                </TableRow>
              </TableBody>

              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Updated At
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(easebuzzPaymentModeData["updated_at"])}
                  </TableBodyCell>
                </TableRow>
              </TableBody>
            </table>
          </Grid>
        </CustomTableWrapper>
      </CardContent>
    </Card>
  );
};

export default EasebuzzDetails;
